import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from './store/store.module';
import { UpdateModule } from './update/update.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule,
    UpdateModule
  ]
})
export class ReturnsModule { }
